import '../stylesheets/styles.scss';
import FontFaceObserver from 'fontfaceobserver';
import lazysizes from 'lazysizes';
require('lazysizes/plugins/unveilhooks/ls.unveilhooks');
import 'lazysizes/plugins/bgset/ls.bgset';
import 'svgxuse';

window.lazySizesConfig = window.lazySizesConfig || {};

lazySizesConfig.lazyClass = 'js-lazyload';

var font = new FontFaceObserver('Muli');

font.load().then(function () {
    document.documentElement.className += " fonts-loaded";
});

document.addEventListener("DOMContentLoaded", function() {

    // if(document.querySelector('.js_slider')) {
    //     var slider = document.querySelector('.js_slider');
    //     lory(slider, {
    //         infinite: 0,
    //         slidesToScroll: 2,
    //         enableMouseEvents: true
    //     });
    // }

    // Open and close profile summaries
    const profileSummaries = document.querySelectorAll('.js-profile');
    Array.from(profileSummaries).forEach(function(el){
        el.querySelector('.js-open-profile').addEventListener('click', function(){
            let activeProfile = document.querySelector('.js-profile.is-active');
            if(activeProfile){
                activeProfile.classList.remove('is-active');
            }
            this.parentElement.classList.add('is-active');
        });
        el.querySelector('.js-close-profile').addEventListener('click', function(){
            this.parentElement.parentElement.classList.remove('is-active');
        })
    });

    // Mobile menu toggle
    const navList = document.querySelector('.js-nav-list');
    document.querySelector('.js-menu-toggle').addEventListener('click', function(){
       this.classList.toggle('is-active');
       navList.classList.toggle('is-active');
    });

    // Sticky header
    // get the sticky element with the id of `sticky-header`.
    var stickyHeader = document.querySelector('.js-sticky-header');

    // then record the current position, so when we cross the
    // boundary the `sticky` class can be toggled
    var boundary = stickyHeader.offsetHeight;

    // when the page scrolls, do as little as possible, in this
    // case we're just registering a rAF callback to `checkSticky`
    window.onscroll = function (event) {
        requestAnimationFrame(checkSticky);
    };

    function checkSticky() {
        // collect current scroll position, with a arbitrary amount
        // of inertia.
        var y = window.scrollY + 2;

        // check if the element contains the `sticky` class already
        var isSticky = document.body.classList.contains('sticky');
        if (y > boundary) {
            // if we're in the "sticky" boundary, and it's not already
            // sticky, then apply the class, otherwise do nothing.
            if (!isSticky) {
                document.body.classList.add('sticky');
            }
        } else if (isSticky) {
            // otherwise, we're inside the region *and* the sticky
            // class needs to be removed.
            document.body.classList.remove('sticky');
        }
    }

});


// WEBPACK FOOTER //
// ./src/javascripts/global.js